// @ts-check
import { UNIFIEDDATE_VALUES } from "./CompoundRangeDatePicker"
import { Role } from "./roles.consts"

/**
 * @type {import("../types/shortcuts").ShortcutItem[]}
 */
export const SHORTCUT_ITEMS = [
  {
    title: "Reporte de tareas CxVET",
    description: "Descargar último reporte mensual disponible:",
    to: "/reporte-general/horas-cliente",
    clientCode: "CVT",
    state: {
      period: UNIFIEDDATE_VALUES.SINGLEMONTH,
      dateRange: "last-month",
    },
    visibility: {
      roles: [Role.ADMIN, Role.ADMIN_WITHOUT_REPORT],
    },
  },
  {
    title: "Reporte de consumo Getro",
    description: "Descargar último reporte disponible:",
    to: "/reporte-general/horas-cliente",
    clientCode: "GTR",
    state: {
      period: UNIFIEDDATE_VALUES.RANGEDAY,
      dateRange: "start-date-to-today",
      dateRangeStart: "2022-12-01",
    },
    visibility: {
      roles: [Role.TEAM_LEADER],
    },
  },
]
